module.exports = __webpack_public_path__ + "img/new-group-logo.bcc783ec.png";